<div class="p-inputgroup">
  <ng-content></ng-content>
  <span class="p-inputgroup-addon">
    <fa-icon [icon]="icon"></fa-icon>
  </span>
</div>
